import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Apotheosis — The Unmade King's phase-2-exclusive ultimate. Only becomes
 * pickable once it drops below 50% HP (see SpawningSystem's phase2Pattern
 * handling) — the reward for surviving to its "true form" is also the
 * single biggest threat window in the run. Goes briefly invulnerable (like
 * Desperation Shield) while unleashing a sustained multi-burst barrage, each
 * burst's bullets swelling as they travel (BossBullet's growPerDistance).
 *
 * `config` (burstCount/burstInterval/ringCount/damage/speed) is per-boss
 * tuning, supplied by data/bosses.js.
 */
export class Apotheosis extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Apotheosis', telegraphDuration: 1.2, activeDuration: 2.4, minPhase });
    this.config = config;
  }

  onActiveStart(boss) {
    boss.invulnerable = true;
    this._burstTimer = 0;
    this._burstsFired = 0;
  }

  onActiveTick(dt, boss, _player, pool) {
    this._burstTimer -= dt;
    if (this._burstTimer <= 0 && this._burstsFired < this.config.burstCount) {
      this._fireBurst(boss, pool, this._burstsFired);
      this._burstsFired++;
      this._burstTimer = this.config.burstInterval;
    }
  }

  onEnd(boss) {
    boss.invulnerable = false;
  }

  _fireBurst(boss, pool, index) {
    const { ringCount, damage, speed } = this.config;
    const offset = index * 0.2;
    for (let i = 0; i < ringCount; i++) {
      const angle = offset + (i / ringCount) * Math.PI * 2;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 3,
        damage,
        color: '#ff5d6c',
        lifetime: 3.5,
        growPerDistance: 0.04,
      });
    }
  }

  getVisual(boss) {
    if (this.state === PatternState.ACTIVE) return { kind: 'shield', x: boss.x, y: boss.y };
    if (this.state === PatternState.TELEGRAPH) return { kind: 'flash', x: boss.x, y: boss.y, color: '#ff5d6c' };
    return null;
  }
}
